import { posthogTag } from '@core/analytics/posthog-tag.js';
import { sentryTag } from '@core/observability/sentry-tag.js';

import type { Tag } from './types.js';

/**
 * Single source of truth — every third-party tag/tracker the SPA loads
 * registers here. The container ([`index.ts`](./index.ts)) iterates this
 * list on every c15t lifecycle event and every validated `track()` call, so
 * adding a new tag is a one-import change in this file and the consent-
 * provider never has to mention the vendor by name.
 *
 * Per-vendor implementations live next to their other helpers
 * (`core/analytics/<vendor>-tag.ts`, `core/observability/<vendor>-tag.ts`,
 * etc.) so the implementation stays colocated with its SDK init/identify/
 * reset. This file owns registration only.
 */
export const tags: ReadonlyArray<Tag> = [
  // Sentry first: registering the user-context machine before PostHog's
  // identify reaches it keeps Sentry's user attached to PostHog-attributed
  // breadcrumbs on the first identify cycle.
  sentryTag,
  posthogTag,
  // Future tags follow the same pattern, e.g.:
  //   linkedinInsightTag,
  //   metaPixelTag,
];
